module.exports = __webpack_public_path__ + "static/media/harikishoresreenivasalu.51bd98c2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/harikishoresreenivasalu.webp
// module id = 504
// module chunks = 0